/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PcmsHubJuvenileReferralResponse { 
    /**
     * Exact opaque CRD Program OID; preserve case and value without normalization
     */
    crdProgramId?: string;
    /**
     * Exact opaque CRD ProgramReferral OID; preserve case and value without normalization
     */
    crdReferralId?: string;
    pcmsIndividualId?: number;
    pcmsReferralId?: number;
    pcmsServiceProviderId?: number;
    referralDate?: string;
    referralStatus?: PcmsHubJuvenileReferralResponse.ReferralStatusEnum;
    referralStatusAt?: string;
}
export namespace PcmsHubJuvenileReferralResponse {
    export const ReferralStatusEnum = {
        Pending: 'PENDING',
        Accepted: 'ACCEPTED',
        Active: 'ACTIVE',
        Completed: 'COMPLETED',
        Cancelled: 'CANCELLED',
        Rejected: 'REJECTED',
        Removed: 'REMOVED'
    } as const;
    export type ReferralStatusEnum = typeof ReferralStatusEnum[keyof typeof ReferralStatusEnum];
}


